import { gql, useMutation, ApolloError } from '@apollo/client';
import { DuplicateLesson, DuplicateLessonVariables } from '../__generated__/gql-types/DuplicateLesson';

const GET_LESSONS = gql`
  query GetLessonsToDuplicate {
    getLessons {
      id
      title
      deleted_at
      course_id
      grade {
        name
        id
      }
      lesson_type
    }
  }
`;

const GET_LESSONS_LIST_BACKOFFICE = gql`
  query getLessonsListBackOfficeForDuplicate {
    getLessonsListBackOffice {
      id
      title
      deleted_at
      course_id
      grade {
        name
        id
      }
      lesson_type
    }
  }
`;

const DUPLICATE_LESSON = gql`
  mutation DuplicateLesson($id: ID!, $newTitle: String!) {
    duplicateLesson(id: $id, newTitle: $newTitle) {
      id
      title
      description
      lesson_type
      grade {
        id
        name
      }
      subject {
        id
        name
      }
      deleted_at
      course_id
      lesson_content_id
      lesson_content @include(if: true) {
        id
        pdf
        slide
        responses_pdf
      }
    }
  }
`;

const useDuplicateLesson = () => {
  const [mutate, { loading, error }] = useMutation<DuplicateLesson, DuplicateLessonVariables>(
    DUPLICATE_LESSON,
    {
      refetchQueries: [
        { query: GET_LESSONS },
        { query: GET_LESSONS_LIST_BACKOFFICE }
      ],
      awaitRefetchQueries: true,
      fetchPolicy: 'network-only'
    }
  );

  return {
    duplicateLesson: async (input: DuplicateLessonVariables) => {
      try {
        const result = await mutate({
          variables: input,
        });

        if (result.errors) {
          throw new ApolloError({
            graphQLErrors: result.errors,
          });
        }

        return result.data?.duplicateLesson;
      } catch (e) {
        throw e;
      }
    },
    loading,
    error,
  };
};

export default useDuplicateLesson;
